export default {
  domain: null,
};
